import styled from 'styled-components'
import {darkGray, airBlue} from '@modifi/colors'
import {Col, media as _media} from '@modifi/ui'

import {A} from '../../styles/typography'

type mediaType = Record<string, any>

const media = _media as mediaType

export const CardWrapper = styled.div``

export const WhatsAppLink = styled(A)`
  display: inline-flex;
  align-items: center;
  color: ${darkGray};

  > svg {
    margin-right: 5px;
  }
`

export const PhoneNumber = styled(A)`
  color: ${airBlue};
  font-weight: 600;
`

export const TabsCol = styled(Col)`
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  ${media.smaller`
    -webkit-overflow-scrolling: touch;

  `}
`

type requestDemoWrapperType = {
  visibility?: string
}

export const RequestDemoWrapper = styled.div<requestDemoWrapperType>`
  visibility: ${({visibility = 'visible'}): string => visibility};
`
